import { rolesList } from '../../../redux/auth';

export const PERMISSION_OPTIONS = [
  {
    id: rolesList.ADMINISTRATOR,
    label: 'Administrador',
  },
  {
    id: rolesList.DASHBOARD,
    label: 'Dashboard',
    subOptions: [
      {
        id: rolesList.DASHBOARD_ONGOING,
        label: 'Em andamento',
      },
      {
        id: rolesList.DASHBOARD_HISTORY,
        label: 'Realizado',
      },
      {
        id: rolesList.FORECAST,
        label: 'Planejado x Realizado',
      },
    ],
  },
  {
    id: rolesList.TRACKING,
    label: 'Tracking Integrado',
  },
  {
    id: rolesList.RECIPIENT_TRACKING,
    label: 'Tracking Destinatário',
  },
  {
    id: rolesList.ADMIN_CUSTOMER,
    label: 'Administrador Cliente',
  },
  {
    id: rolesList.NUFARM,
    label: 'Nufarm',
  },
  {
    id: rolesList.STOCK,
    label: 'Estoque',
  },
  {
    id: rolesList.GENERAL_WAREHOUSE,
    label: 'Armazém Geral',
  },
  {
    id: rolesList.SCHEDULING,
    label: 'Agendamento',
  },
  {
    id: rolesList.OPERATIONAL,
    label: 'Operacional',
    subOptions: [
      {
        id: rolesList.TRAVEL_MONITORING,
        label: 'Acompanhamento de Viagens',
      },
      {
        id: rolesList.VEHICLES,
        label: 'Veículos',
      },
      {
        id: rolesList.MANIFESTS_IN_TRANSIT,
        label: 'Manifestos em Trânsito',
      },
    ],
  },
  {
    id: rolesList.DASHBOARD_DISCHARGES,
    label: 'Baixas do App',
  },
  {
    id: rolesList.CARBON_EMISSIONS,
    label: 'Emissões de CO2',
  },
  {
    id: rolesList.NOTES_CONNECTION,
    label: 'Conexão de Notas',
  },
];

export const USER_TYPES = {
  LUFT_USER: 1,
  PLATFORM_USER: 2,
  CUSTOMER_SERVICE_USER: 3,
  OPERATIONS: 5,
};

export const branchesIds = {
  LUFT_AGRO: 1,
  LUFT_HC: 2,
};

export const BRANCHES_OPTIONS_USER = [
  {
    id: 1,
    label: 'Luft Agro',
  },
  {
    id: 2,
    label: 'Luft Healthcare',
  },
  {
    id: 3,
    label: 'Transcamila',
  },
];

export const BRANCHES_OPTIONS_COMPANY = [
  {
    id: 1,
    label: 'Luft Agro',
  },
  {
    id: 2,
    label: 'Luft Healthcare',
  },
  {
    id: 3,
    label: 'Transcamila',
  },
];

export const SUBSIDIARY_OPTIONS = [
  {
    id: 1,
    label: '01 - AGRO - MATRIZ',
  },
  {
    id: 4,
    label: '02 - PORTO ALEGRE',
  },
  {
    id: 5,
    label: '03 - LOG - IBIPORA',
  },
  {
    id: 7,
    label: '05 - AGRO - BARUERI',
  },
  {
    id: 8,
    label: '05 - LOG - AP. DE GOIANIA',
  },
  {
    id: 10,
    label: '08 - LOG - BARUERI',
  },
  {
    id: 13,
    label: '11 - LOG - L.E.M.',
  },
  {
    id: 14,
    label: '15 - LOG - CARAZINHO',
  },
  {
    id: 15,
    label: '16 - AGRO - CURITIBA',
  },
  {
    id: 16,
    label: '27 - AGRO - ITUVERAVA',
  },
  {
    id: 17,
    label: '28 - AGRO - GUARATINGUETA',
  },
  {
    id: 18,
    label: '30 - AGRO - CUIABA',
  },
  {
    id: 19,
    label: '31 - AGRO - AP. DE GOIANIA',
  },
  {
    id: 20,
    label: '32 - AGRO - L.E.M.',
  },
  {
    id: 21,
    label: '35 - AGRO - BELFORD ROXO',
  },
  {
    id: 22,
    label: '50 - AGRO - IBIPORA',
  },
  {
    id: 23,
    label: '53 - AGRO - AGUDOS',
  },
  {
    id: 24,
    label: '54 - AGRO - PIRAI',
  },
  {
    id: 25,
    label: '55 - AGRO - PAULINIA',
  },
  {
    id: 26,
    label: '56 - AGRO - CARAZINHO',
  },
  {
    id: 27,
    label: '57 - AGRO - PORTO ALEGRE',
  },
  {
    id: 28,
    label: '71 - AGRO - UBERABA',
  },
  {
    id: 29,
    label: '77 - AGRO - JACAREI',
  },
  {
    id: 30,
    label: '83 - AGRO - BARUERI',
  },
  {
    id: 31,
    label: '90 - AGRO - SORRISO',
  },
  {
    id: 32,
    label: '91 - AGRO - SORRISO',
  },
  {
    id: 34,
    label: 'LUFT',
  },
  {
    id: 35,
    label: 'LUFT - BARUERI/SP',
  },
  {
    id: 36,
    label: 'LUFT - CARAZINHO/RS',
  },
  {
    id: 37,
    label: 'LUFT - CUIABÁ/MT',
  },
  {
    id: 38,
    label: 'LUFT - GOIANIA/GO',
  },
  {
    id: 39,
    label: 'LUFT - LEM/BA',
  },
  {
    id: 40,
    label: 'LUFT - SORRISO/MT',
  },
  {
    id: 41,
    label: 'LUFT AGRO - CUIABA/MT NOVO',
  },
  {
    id: 42,
    label: 'LUFT AGRO - IBIPORÃ/PR',
  },
];
